import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  chatObjects: [], 
};

const chatObjectsSlice = createSlice({
  name: 'chatObjects',
  initialState,
  reducers: {
    setChatObjects(state, action) {
      state.chatObjects = action.payload;
    },
  },
});

export const { setChatObjects } = chatObjectsSlice.actions;

export default chatObjectsSlice.reducer;